import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import CreditLedgerEntry from "./credit-ledger-entry";
import {setWorkspaceGraphCreditLedgerEntries, workspaceGraphSelectors} from "../../system/workspace-graph-slice";

export function useCreditLedgerEntry() {
    const dispatch = useDispatch();
    const creditLedgerEntries = useSelector(workspaceGraphSelectors.creditLedgerEntries);

    const getCreditLedgerEntries = useCallback(async (workspaceId) => {
        if (!workspaceId) return [];
        const model = new CreditLedgerEntry();
        const data = await model.getAll({populate: "*", sort: ["occurredAt:desc"]});
        const items = data?.data || [];
        dispatch(setWorkspaceGraphCreditLedgerEntries(items));
        return items;
    }, [dispatch]);

    return {creditLedgerEntries, getCreditLedgerEntries};
}
